import axios from 'axios';
import reactCookie from 'react-cookie';
import { envValue } from '../config/envUtils';
import Url from './config';
import store from '../src/store/Store';
import { ACCESS_POINT_LEVEL, ACCESS_POINTS_GROUP } from '../src/constants/AccessPoints';

const axiosInstance = axios.create();
axiosInstance.defaults.timeout = 60000;
axiosInstance.defaults.baseURL = Url.host;
axiosInstance.defaults.headers.common['X-Requested-With'] = 'Sabre Site Builder client';
axiosInstance.defaults.headers.common['app-env'] = envValue('ENV_CODE') || '';

const auth = reactCookie.load('auth', false);
if (auth) {
  if (auth.access_token) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${auth.access_token}`;
  }
}
// interceptors are called on every REQ _before_ the promises in the component
axiosInstance.interceptors.request.use(
  config => config,
  (error) => {
    store.dispatch({ type: 'HTTPCLIENT_REQUEST_ERROR', payload: error });
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  response => response,
  (error) => {
    store.dispatch({ type: 'HTTPCLIENT_RESPONSE_ERROR', payload: error });
    return Promise.reject(error);
  }
);

function setNativeValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
        valueSetter.call(element, value);
    }
}

function insertAtCursor(field, myValue) {
    let endPos;
    let startPos;
//IE support
    if (document.selection) {
        field.focus();
        sel = document.selection.createRange();
        sel.text = myValue;
    }
    // Microsoft Edge
    else if(window.navigator.userAgent.indexOf("Edge") > -1) {
        startPos = field.selectionStart;
        endPos = field.selectionEnd;
        setNativeValue(field, field.value.substring(0, startPos)+ myValue
            + field.value.substring(endPos, field.value.length))
        const pos = startPos + myValue.length;
        field.focus();
        field.setSelectionRange(pos, pos);
    }
    //MOZILLA and others
    else if (field.selectionStart || field.selectionStart == '0') {
        startPos = field.selectionStart;
        endPos = field.selectionEnd;
        setNativeValue(field, field.value.substring(0, startPos)
            + myValue
            + field.value.substring(endPos, field.value.length));
    } else {
        setNativeValue(field, field.value + myValue);
    }
}

function injectTheme(styleTemplate, themeData, currentTheme) {
    return styleTemplate.replace(/\/?\@([a-zA-Z0-9\.]+)\@\/?/g, (match, key) => {
      const theme = {
        ...currentTheme,
        button: themeData.buttons.button,
        palette: themeData.colors,
        background: themeData.colors.background,
        h1: themeData.global.h1,
        h2: themeData.global.h2,
        h3: themeData.global.h3,
        h4: themeData.global.h4,
        h5: themeData.global.h5,
        font: themeData.global.font,
        link: themeData.buttons.link,
        heroImage: themeData.header.heroImage,
        header: {
          ...currentTheme.header,
          userBar: {
            ...themeData.header.userBar
          },
          hamburgerMenu: {
            ...themeData.header.hamburgerMenu
          }
        },
        calendar: themeData.calendar.calendar,
        gallery:themeData.carousel.gallery
      }
      //Do path search
        return get(theme, key, get(currentTheme, key, ''));
    });
}
function formatBytes(a,b){if(0==a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]}

String.prototype.ucFirst = function(){
    return this.charAt(0).toUpperCase() + this.slice(1);
}

function getText(domElement) {
    const root = domElement;
    const text = [];

    function traverseTree(root) {
        Array.prototype.forEach.call(root.childNodes, function(child) {
            if (child.nodeType === 3) {
                const str = child.nodeValue.trim();
                if (str.length > 0) {
                    text.push(str);
                }
            } else {
                traverseTree(child);
            }
        });
    }
    traverseTree(root);
    return text.join(' ');
}

const noop = () => {};

/**
 * From Sabre-Spark
 * # Has Parent
 * See if an element has another element for a parent.
 *
 * @param {Element} child
 * @param {Element} possibleParent
 * @return {Boolean}
 *
 * @module helpers/traversal/has-parent.js
 */
function hasParent(child, possibleParent) {

    let parent = child.parentNode;

    while (parent) {

        if (parent === possibleParent) {
            return true;
        }

        parent = parent.parentNode;
    }

    return false;
}

function checkPermissions(state, key) {
    const hasAccessToCurrentLevel = _.indexOf(state.oauth.userPermissionLevels, state.app.selected.level) !== -1
    return {
        add: hasAccessToCurrentLevel && _.get(state.oauth.accessLevel, key, []).includes(ACCESS_POINT_LEVEL.ADD),
        edit: hasAccessToCurrentLevel && _.get(state.oauth.accessLevel, key, []).includes(ACCESS_POINT_LEVEL.EDIT),
        delete: hasAccessToCurrentLevel && _.get(state.oauth.accessLevel, key, []).includes(ACCESS_POINT_LEVEL.DELETE),
        view: _.get(state.oauth.accessLevel, key, []).includes(ACCESS_POINT_LEVEL.VIEW)
    }
}

function checkPermissionForLevel(object, key, methodName, userPermissionLevels, selectedLevel) {
    return _.get(object, key, []).includes(methodName) && _.indexOf(userPermissionLevels, selectedLevel) !== -1;
}

export {
  getText,
  axiosInstance as httpClient,
  injectTheme,
  insertAtCursor,
  setNativeValue,
  formatBytes,
  hasParent,
  noop,
  checkPermissions,
  checkPermissionForLevel
};



// WEBPACK FOOTER //
// ./lib/utils.js